module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/digestifs-et-bonne-compagnie.json
// module id = 582
// module chunks = 132194899052146